<template>
  <div class="achievement-info">
    <!-- <div class="info-achievement">
      <div class="titles">
        <div class="title">{{ examDetails.title }}</div>
        <div class="subTitle">{{ examDetails.subTitle }}</div>
      </div>
      <div class="date">
        <i class="iconfont icon-date" /> 考试时间：{{ examDetails.startTime }}
      </div>
    </div> -->
    <div class="info-student">
      <div class="left">
        <div class="head-name">
          <!-- <el-image
            :src="examDetails[0].headPortrait"
            class="userinfo-img"
            :preview-src-list="[examDetails[0].headPortrait]"
            ><div
              slot="error"
              class="image-slot"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f5f7fa;
                color: #c0c4cc;
                font-size: 12px;
              "
            >
              <div>暂无图片</div>
            </div></el-image
          > -->
          <div>
            <!-- <span class="name">学生姓名：{{ examDetails[0].studentName }}</span>
            <div class="number">学号：{{ examDetails[0].studentNumber }}</div> -->
            <el-button type="success" size="small" @click="derivedScore" v-hasPermi="'sc:studentscore:export'">导出成绩</el-button>
            <!-- <span class="class-name">{{
              examDetails.gradeName
            }}</span> -->
          </div>
        </div>
      </div>
      <!-- <div class="right">
        <div class="title">班级排名</div>
        <img
          class="img"
          v-if="examDetails.ranks <= 3"
          :src="
            examDetails.ranks == 1
              ? urlFirst
              : examDetails.ranks == 2
              ? urlSecond
              : examDetails.ranks == 3
              ? urlThird
              : ''
          "
        />
        <div class="content" v-if="examDetails.ranks > 3">
          {{ examDetails.ranks }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    examDetails: {
      type: [Array],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 第一名
      urlFirst: require("@/assets/image/achievement/first.png"),
      urlSecond: require("@/assets/image/achievement/second.png"),
      urlThird: require("@/assets/image/achievement/third.png"),
    };
  },
  methods: {
    derivedScore() {
      this.$emit("derivedScore");
    },
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  filters: {
  }
};
</script>

<style lang="scss" scoped>
@import "./achievement-info.scss";
</style>